<template>
  <v-container
    class="timeline-item-container d-flex align-center justify-center pa-2"
    :class="{ 'timeline-long-press-active': isPressed }"
    @mousedown="interactionHandlers.onPressStart"
    @mouseup="interactionHandlers.onPressEnd"
    @mouseleave="interactionHandlers.onPressCancel"
    @touchstart="interactionHandlers.onPressStart"
    @touchend="interactionHandlers.onPressEnd"
    @touchcancel="interactionHandlers.onPressCancel">
    <!-- Icon -->
    <v-icon v-if="item.icon" :color="item.color" class="mr-2" size="16">
      {{ item.icon }}
    </v-icon>

    <!-- Text -->
    <div class="text-center">
      <div class="text-body-2">
        {{ item.title }}
        <span v-if="showUser" class="text-caption text--secondary">
          ({{ item.user| userName }})
        </span>
      </div>
      <div v-if="item.subtitle" class="text-caption text--secondary">
        {{ item.subtitle }}
      </div>
      <!-- Travel time -->
      <div v-if="item.travelTimeFormatted" class="text-caption text--secondary d-flex align-center justify-center">
        Czas dojazdu: {{ item.travelTimeFormatted }}
      </div>
    </div>

    <!-- Time -->
    <div v-if="item.createdAt" class="text-caption ml-2">
      {{ item.createdAt | timeShort }}
    </div>
  </v-container>
</template>

<script>
import { timelineEditMixin } from '@/mixins/timelineEdit.js'

export default {
  name: 'AtLocationTimelineItem',

  mixins: [timelineEditMixin],

  props: {
    item: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    // New props for configuring edit methods
    enableLongPress: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isPressed: false
    }
  },

  computed: {
    editMethodsConfig() {
      return {
        longPress: this.enableLongPress && this.canEdit
      }
    },

    interactionHandlers() {
      return this.getSafeInteractionHandlers(
        this.item,
        this.handleEdit,
        this.readOnly
      );
    },

    showUser() {
      return this.item.user && !this.item.isCurrentUser;
    },

    canEdit() {
      // For AtLocationItem with travel time editing capability
      if (this.item.type === 'at_location' && this.item.canEditTravelTime) {
        return true;
      }
      // Standard edit logic - check only canEdit and source
      return (this.item.canEdit !== false) && !!this.item.source;
    }
  },

  mounted() {
    // Set edit methods for mixin - required by timelineEditMixin
    this.editMethods = this.editMethodsConfig;
  },

  methods: {
    // Override mixin method - fix for missing editMethod
    canEditItem(item) {
      // For AtLocationItem with travel time editing capability
      if (item.type === 'at_location' && item.canEditTravelTime) {
        return true;
      }
      // Standard logic without checking editMethod
      const result = item.canEdit !== false && !this.readOnly;
      return result;
    },

    handleEdit() {
      // Special handling for AtLocationItem with travel time editing
      if (this.item.type === 'at_location' && this.item.canEditTravelTime) {
        this.$emit('edit-travel-time', { item: this.item });
        return;
      }

      // Standard editing - emit event to parent
      this.$emit('edit', { item: this.item });
    }
  }
}
</script>

<style scoped>
/* Component-specific styles only - shared timeline styles are in src/styles/overrides.sass */
</style>
